// Exact milli-unit (0.001) arithmetic with BigInt — mirrors backend Decimal ROUND_HALF_UP.

export function toMilli(raw) {
    const s = String(raw ?? "").trim().replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace("٫", ".");
    if (!/^\d+(\.\d{0,3})?$/.test(s)) return null;
    const [i, f = ""] = s.split(".");
    return BigInt(i) * 1000n + BigInt((f + "000").slice(0, 3));
}

function divRound(n, d) {
    const neg = n < 0n;
    const a = neg ? -n : n;
    const q = (a * 2n + d) / (2n * d);
    return neg ? -q : q;
}

const mul = (a, b) => divRound(a * b, 1000n);

export function fmtMilli(m) {
    if (m === null || m === undefined) return "—";
    const v = typeof m === "bigint" ? m : toMilliSigned(m);
    if (v === null) return "—";
    const neg = v < 0n;
    const a = neg ? -v : v;
    const int = (a / 1000n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const frac = (a % 1000n).toString().padStart(3, "0");
    return `${neg ? "-" : ""}${int}.${frac}`;
}

export function toMilliSigned(raw) {
    const s = String(raw ?? "").trim();
    if (s.startsWith("-")) {
        const m = toMilli(s.slice(1));
        return m === null ? null : -m;
    }
    return toMilli(s);
}

export function signOf(raw) {
    const m = typeof raw === "bigint" ? raw : toMilliSigned(raw);
    if (m === null) return 0;
    return m > 0n ? 1 : m < 0n ? -1 : 0;
}

export function sanitizeDecimal(v) {
    let s = String(v).replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace("٫", ".").replace(/[^\d.]/g, "");
    const i = s.indexOf(".");
    if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "").slice(0, 3);
    return s;
}

export function calcSale({ weight, gold_price, customer_mfg, cost_mfg, vat_enabled = true }) {
    const w = toMilli(weight), p = toMilli(gold_price);
    const cm = toMilli(customer_mfg || "0"), cost = toMilli(cost_mfg || "0");
    if (w === null || p === null || cm === null || cost === null || w === 0n || p === 0n) return null;
    const base = mul(w, p);
    const mfg = mul(w, cm);
    const pre = base + mfg;
    const vat = vat_enabled ? divRound(pre * 5n, 100n) : 0n;
    const total = pre + vat;
    const profit = mul(w, cm - cost);
    return { gold_value: base, manufacturing: mfg, price_before_tax: pre, vat, price_after_tax: total, due_from_customer: total, profit };
}

export function calcPurchase({ weight, market_price, buy_price }) {
    const w = toMilli(weight), m = toMilli(market_price), b = toMilli(buy_price);
    if (w === null || m === null || b === null || w === 0n || m === 0n || b === 0n) return null;
    return { market_value: mul(w, m), paid_to_seller: mul(w, b), profit: mul(w, m - b) };
}

export const OP_LABELS = { sale: "بيع ذهب جديد", purchase: "شراء ذهب مستعمل", expense: "مصاريف" };
export const MONTHS_AR = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
